import { refresh } from "../utils/refresh";
import { history } from "../store";
import { apigClientFactory } from "../apiGateway/apigClientFactory";
import { ACTION_NAMES } from "../utils/actionConstants";

const unloadConfiguration = () => ({
  type: ACTION_NAMES.CONFIGURATION.REQUEST_CONFIGURATION,
  payload: null,
});

const requestConfiguration = () => ({
  type: ACTION_NAMES.CONFIGURATION.REQUEST_CONFIGURATION,
  payload: null,
});

const receiveConfiguration = (configuration) => ({
  type: ACTION_NAMES.CONFIGURATION.RECEIVE_CONFIGURATION,
  payload: configuration,
});

export const actions = {
  unload: () => (dispatch, getState) => {
    dispatch(unloadConfiguration());
  },

  load: () => async (dispatch, getState) => {
    const state = getState();

    try {
      await refresh(state.auth.auth);
    } catch (error) {
      console.log("Refresh Error: " + error);
      history.push("/logout");
      return;
    }

    var apigClient;
    var params = {
      Authorization: `Bearer ${state.auth.auth.secret}`,
    };

    if (process.env.REACT_APP_API_GATEWAY) {
      apigClient = apigClientFactory.newClient({
        invokeUrl: process.env.REACT_APP_API_GATEWAY,
      });
    } else {
      apigClient = apigClientFactory.newClient();
    }

    dispatch(requestConfiguration());

    apigClient
      .configurationGet(params)
      .then((result) => {
        console.log("success getting configuration data");
        dispatch(receiveConfiguration(result.data));
      })
      .catch((error) => {
        console.log(error);
        console.log("Load Configuration Data failed!!");
        //TODO handle error
      });
  },
};
